
import { Component, OnInit, ChangeDetectorRef, NgZone, inject, PLATFORM_ID, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { UsersService } from '../../services/users.service';
import { SettingsService } from '../../services/settings.service';
import { CommonService } from '../../services/common.service';
import { AuthService } from '../../services/auth.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, firstValueFrom } from 'rxjs';
import { HostListener } from '@angular/core';
import { RolesService } from '../../services/roles.service';

@Component({
  selector: 'app-users',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, HeaderComponent],
  templateUrl: './users.component.html',
  styleUrls: []
})
export class UsersComponent implements OnInit {
  copyrightDetails: any;
  isLocationChanged = false;
  isLoaded = false;
  isLoading = true;
  isRefreshTable = false;
  isResettingPassword = false;  // Add this with your other variables
  // Add this variable
  isUpdating: boolean = false;
  isRoleLoaded = false;
  isRoleLoading = true;
  isSessionLoaded = false;
  isSessionLoading = true;
  isLocationLoaded = false;
  isLocationLoading = true;
  availableLocationsList: any[] = [];
  totalRecords = 0;
  totalRecordsText = '';
  refreshTableText = '';
  showDeleteModal = false;
  deleteUserId: number | null = null;
  deleteMessage = '';


  passwordPolicy: any = null;
  policyErrors: string[] = [];

  allUsers: any[] = [];
  users: any[] = [];
  roleSearch = '';
  // Filtering

  search = '';
  statusFilter = 'all';
  locationFilter = 'all';
  showBlockedOnly = false;
  uniqueLocations = signal<string[]>([]);
  locationSearch = '';

  showAssignLocationDropdown = false;

  assignLocationSearch = '';

  selectedAssignLocationId: any = '';

  selectedAssignLocationName = '';

  showStatusDropdown = false;
  showLocationDropdown = false;

  // Add these with your other class variables
  sessionStats: any = null;
  isSessionStatsLoading = false;
  showSessionStatsModal = false;

  // Pagination & Display limit
  currentPage = 1;
  pageSize = 10;
  sortType = 'name';
  sortReverse = false;

  // Selected User State
  showUserDetails = false;
  selectedUser: any = null;
  userDetails: any = {};
  activeTab = 'summary';

  // Details state
  currentUserRolesList: any[] = [];
  accessRolesList: any[] = [];
  availableRolesList: any[] = [];
  userSessions: any[] = [];
  baseLocationsList: any[] = [];
  allLocationsList: any[] = [];

  // Forms
  isCreateUser = false;
  isUpdateProfile = false;
  isUpdatePassword = false;
  userFormObj: any = {};
  passwordFormObj: any = {};
  oldUserDetails: any = {};

  // UI States
  passwordVisible = false;
  confirmPasswordVisible = false;

  /*   // UI States
    passwordVisible = false;
    confirmPasswordVisible = false; */

  // Preferences
  allPreferences: any[] = [];
  storePreferencesMap: any = {};

  enableDisableBtnText = 'Disable';
  showUnblockConfirmation = false;

  message: string | null = null;
  createmessage: string | null = null;
  message1: string | null = null;
  userMessage: string | null = null;
  messageColor = 'green';
  errorMessage: string | null = null;
  // Look at the top of your class variables and add it there:
  canHardDelete: any = false;

  storeManager: any;




  //Column Visibility
  isColumnSettingsVisible = false;
  columnVisibility: { [key: string]: boolean } = {
    name: true,
    username: true,
    status: true,
    email: true,
    base_location: true,
    is_service_accounts: true,
    action: true,
    view: true
  };

  constructor(
    private usersService: UsersService,
    private settingsService: SettingsService,
    private common: CommonService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private authService: AuthService,
    private rolesService: RolesService,
  ) { }

  private platformId = inject(PLATFORM_ID);

  async ngOnInit(): Promise<void> {

    this.showUserDetails = false;
    this.userDetails = {};
    this.canHardDelete = false; // Initialize to false by default

    // 1. CRITICAL SSR GUARD: Stop execution here if running on the server side
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    // --- ALL BROWSER / SESSION STORAGE CODE GOES SAFELY BELOW THIS LINE ---
    if (typeof window !== 'undefined') {
      const savedDetails = sessionStorage.getItem('copyrightDetails');
      if (savedDetails) {
        this.copyrightDetails = JSON.parse(savedDetails);
      }
    }

    // 2. Fetch Store Manager configuration
    try {
      const smStr = this.common.SessionMemory.API.Get('store_manager');
      if (smStr && smStr !== 'undefined') {
        this.storeManager = JSON.parse(smStr);
      } else {
        this.storeManager = null;
      }
    } catch (e) {
      this.storeManager = null;
    }

    // 3. Fetch User ID using your custom session memory utility method
    const userId = this.common.SessionMemory.API.Get('user.id') || localStorage.getItem('user_id');
    console.log('Current User ID:', userId);

    // 4. Fetch fresh roles from the API and check for role_id 41
    if (userId) {
      this.usersService.getUserRole(userId)
        .then((res: any) => {


          const userRoleList = res.data || res || [];
          sessionStorage.setItem('user_role', JSON.stringify(userRoleList));

          // Evaluate if logged-in user possesses role_id 41 (RC Support)
          if (Array.isArray(userRoleList)) {
            this.canHardDelete = userRoleList.some((role: any) => role.role_id === 41 || role.id === 41);
          } else {
            this.canHardDelete = (userRoleList.role_id === 41 || userRoleList.id === 41);
          }
          this.cdr.detectChanges();
        })
        .catch((err) => {
          console.error('Error fetching user roles:', err);
          this.canHardDelete = false;
        });
    }

    // 5. Wait for user context validation and bootstrap main data grid load
    try {
      await firstValueFrom(
        toObservable(this.authService.user).pipe(
          filter(u => !!u)
        )
      );
      this.loadUsers(false);
    } catch {
      // Fallback gracefully to grid load if authentication signal times out
      this.loadUsers(false);
    }
  }

  /*   loadUsers(isRefresh: boolean = false, isRetry: boolean = false): void {
      if (isRefresh) {
        this.isRefreshTable = true;
        this.totalRecords = 0;
        this.showUserDetails = false;
        this.refreshTableText = 'Table is refreshing...';
        this.allUsers = [];
        this.users = [];
        this.uniqueLocations.set([]);
      }
      this.isLoaded = false;
  
      const columns = [
        "id", "name", "username", "recovery_email",
        "base_location", "status", "is_service_accounts", "is_blocked"
      ];
  
      // Logic: Fetch both Graph and Details to mimic legacy behavior
      // We use Promise.all to fetch both simultaneously for better performance
      Promise.all([
        this.usersService.GetUserGraph(columns),
        this.usersService.GetUserDetails()
      ]).then(([graphRes, detailsRes]) => {
  
        let dataList = [];
  
        // --- Legacy Logic: Choose data source based on store_manager flag ---
        if (this.storeManager) {
          // Filter Details response for LSA users
          const rawDetails = detailsRes?.data || detailsRes;
          dataList = Array.isArray(rawDetails)
            ? rawDetails.filter((x: any) => x.is_lsa_ar.split(",").every((y: any) => y == 1))
            : [];
        } else {
          // Use Graph response
          dataList = graphRes?.data || graphRes;
        }
  
        // --- Safety Retry Logic ---
        if (!isRetry && (!dataList || dataList.length === 0) && !isRefresh) {
          console.warn('[UsersComponent] Received 0 users, scheduling retry...');
          setTimeout(() => this.loadUsers(false, true), 500);
          return;
        }
  
        this.allUsers = Array.isArray(dataList) ? dataList : [];
  
        // Sort Alphabetically by Name (as discussed previously)
        this.allUsers.sort((a, b) =>
          (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase())
        );
  
        this.uniqueLocations.set([]);
        this.applyFilters();
  
        // --- Background Location Processing ---
        if (this.allUsers.length > 0) {
          this.allUsers.forEach(user => {
            if (user.base_location) {
              user.searchable_locations = user.base_location;
              this.updateUniqueLocationsList(user.base_location);
            } else {
              this.usersService.GetUserBaseLocations(user.id || user.user_id).then((locResp: any) => {
                if (locResp && locResp.length > 0) {
                  user.searchable_locations = locResp.map((x: any) => x.base_location).join(', ');
                  locResp.forEach((x: any) => this.updateUniqueLocationsList(x.base_location));
                  this.cdr.detectChanges();
                }
              });
            }
          });
        }
  
        this.ngZone.run(() => {
          this.isLoaded = true;
          if (isRefresh) {
            this.totalRecordsText = 'record(s) loaded';
            this.totalRecords = this.allUsers.length;
            this.refreshTableText = 'Successfully refreshed';
            setTimeout(() => {
              this.isRefreshTable = false;
              this.cdr.detectChanges();
            }, 3500);
          }
          this.cdr.detectChanges();
        });
  
      }).catch((err) => {
        console.error('Error in loadUsers sequence', err);
        this.ngZone.run(() => {
          if (isRefresh) {
            this.isRefreshTable = true;
            this.refreshTableText = 'Unsuccessful!';
          }
          setTimeout(() => {
            this.isRefreshTable = false;
            this.cdr.detectChanges();
          }, 2500);
        });
      });
    } */


  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    // Close all dropdowns if click is outside
    if (!target.closest('.relative')) {
      this.locationSearch = '';
      this.assignLocationSearch = '';
      this.showStatusDropdown = false;
      this.showLocationDropdown = false;
      this.showAssignLocationDropdown = false;
    }
  }

  hasFormChanges(): boolean {

    for (let key in this.userFormObj) {

      const oldValue = (this.oldUserDetails[key] ?? '').toString().trim();
      const newValue = (this.userFormObj[key] ?? '').toString().trim();

      if (oldValue !== newValue) {
        return true;
      }
    }

    return false;
  }

  loadUsers(isRefresh: boolean = false, isRetry: boolean = false): void {
    if (isRefresh) {

      this.showStatusDropdown = false;
      this.showLocationDropdown = false;
      this.isLoaded = false;
      // Reset column visibility to default when refreshing
      this.columnVisibility = {
        name: true,
        username: true,
        status: true,
        email: true,
        base_location: true,
        is_service_accounts: true,
        action: true,
        view: true
      };
      this.isRefreshTable = true;
      this.totalRecords = 0;
      this.showUserDetails = false;
      this.refreshTableText = 'Table is refreshing...';
      //this.allUsers = [];
      //this.users = [];
      this.uniqueLocations.set([]);
      // this.clearAllFilters();
    }
    this.isLoaded = false;

    const columns = ["id", "name", "username", "recovery_email", "base_location", "status", "is_service_accounts", "is_blocked"];

    Promise.all([
      this.usersService.GetUserGraph(columns),
      this.usersService.GetUserDetails()
    ]).then(([graphRes, detailsRes]) => {
      let rawList = this.storeManager ? (detailsRes?.data || detailsRes) : (graphRes?.data || graphRes);

      if (!isRetry && (!rawList || rawList.length === 0) && !isRefresh) {
        setTimeout(() => this.loadUsers(false, true), 500);
        return;
      }

      // Grouping Logic: Combine duplicate rows by username
      const grouped = rawList.reduce((acc: any, current: any) => {
        const key = current.username;
        if (!acc[key]) {
          // First time seeing this user: setup object + location list
          acc[key] = {
            ...current,
            all_locations: [current.base_location].filter(l => !!l)
          };
        } else {
          // User exists: add location to their list if it is not already there
          if (current.base_location && !acc[key].all_locations.includes(current.base_location)) {
            acc[key].all_locations.push(current.base_location);
          }
        }
        return acc;
      }, {});

      this.allUsers = Object.values(grouped);

      this.allUsers.sort((a, b) =>
        (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase())
      );

      this.uniqueLocations.set([]);

      // Update searchable locations for the filter dropdown
      this.allUsers.forEach(user => {
        if (user.all_locations && user.all_locations.length > 0) {
          user.searchable_locations = user.all_locations.join(', ');
          user.all_locations.forEach((loc: string) => this.updateUniqueLocationsList(loc));
        }
      });

      this.applyFilters();

      this.ngZone.run(() => {
        this.isLoaded = true;
        if (isRefresh) {
          this.totalRecords = this.allUsers.length;
          this.refreshTableText = 'Successfully refreshed';
          setTimeout(() => { this.isRefreshTable = false; this.cdr.detectChanges(); }, 3500);
        }
        this.cdr.detectChanges();
      });
    }).catch((err) => {
      console.error('Error in loadUsers sequence', err);
    });
  }


  trimFullName(event: FocusEvent): void {
    if (this.userFormObj.name) {
      // 1. Trim the actual model data
      this.userFormObj.name = this.userFormObj.name.trim();

      // 2. Force the raw input element value to update instantly
      const inputElement = event.target as HTMLInputElement;
      inputElement.value = this.userFormObj.name;
    }
  }
  updateUniqueLocationsList(locationName: string): void {
    if (!locationName) return;
    const parts = locationName.split(', ');

    this.uniqueLocations.update(current => {
      let hasNew = false;
      const newList = [...current];
      parts.forEach(part => {
        if (part && !newList.includes(part)) {
          newList.push(part);
          hasNew = true;
        }
      });
      return hasNew ? newList.sort() : current;
    });
  }

  applyFilters(): void {
    this.users = this.allUsers.filter(user => {
      const uStat = user.status ? user.status.toLowerCase() : '';
      const matchesStatus = (this.statusFilter === 'all' || !this.statusFilter) || (uStat === this.statusFilter.toLowerCase());
      const matchesBlocked = !this.showBlockedOnly || (user.is_blocked === 3);
      let matchesLocation = true;
      if (this.locationFilter !== 'all' && this.locationFilter) {
        matchesLocation = user.searchable_locations && user.searchable_locations.includes(this.locationFilter);
      }

      let matchesSearch = true;
      if (this.search) {
        const term = this.search.toLowerCase();
        matchesSearch = (user.name && user.name.toLowerCase().includes(term)) ||
          (user.username && user.username.toLowerCase().includes(term)) ||
          (user.recovery_email && user.recovery_email.toLowerCase().includes(term));
      }
      return matchesStatus && matchesBlocked && matchesLocation && matchesSearch;
    });

    if (this.sortType) {
      this.users.sort((a, b) => {
        let valA = a[this.sortType] ? String(a[this.sortType]).toLowerCase() : '';
        let valB = b[this.sortType] ? String(b[this.sortType]).toLowerCase() : '';
        if (valA < valB) return this.sortReverse ? 1 : -1;
        if (valA > valB) return this.sortReverse ? -1 : 1;
        return 0;
      });
    }
  }

  setSort(type: string) {
    if (this.sortType === type) {
      this.sortReverse = !this.sortReverse;
    } else {
      this.sortType = type;
      this.sortReverse = false;
    }
    this.applyFilters();
  }

  getPaginatedUsers(): any[] {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    return this.users.slice(startIndex, startIndex + this.pageSize);
  }

  getVisibleCount(): number {
    return Math.min(this.currentPage * this.pageSize, this.users.length);
  }

  pageChange(page: number) {
    this.currentPage = page;
  }

  getTotalPages(): number {
    return Math.ceil(this.users.length / this.pageSize);
  }

  viewUserDetails(user: any, flag?: boolean): void {
    this.selectedUser = user;
    this.loadRolesByUserId();  // Load roles right away
    this.loadBaseLocations();  // Load locations right away
    this.usersService.GetUserDetailsByUserId(user.id || user.user_id).then(details => {
      this.userDetails = details[0] || user;
      this.userDetails.is_blocked = user.is_blocked;

      if (details[0] && details[0].id) {
        this.userDetails.details_id = details[0].id;
      }
      this.showUserDetails = true;
      // 2. Determine which tab to show and LOAD its specific data

      if (flag) {
        this.activeTab = 'roles';
        this.loadRolesByUserId();
      } else {
        this.activeTab = 'summary';
      }
      this.enableDisableBtnText = this.userDetails.status === 'Active' ? 'Disable' : 'Enable';
      this.cdr.detectChanges();
    }).catch(err => {
      console.error('Failed to get user details', err);
    });
  }


  clearAllFilters() {
    this.search = '';
    this.statusFilter = 'all';
    this.locationFilter = 'all';
    this.showBlockedOnly = false;
    this.currentPage = 1;

    // Optional: Clear search inputs in dropdowns
    this.locationSearch = '';
    this.assignLocationSearch = '';

    // Optional: Close dropdowns
    this.showStatusDropdown = false;
    this.showLocationDropdown = false;
    this.showAssignLocationDropdown = false;

    this.applyFilters();
    this.cdr.detectChanges();
  }


  viewUserBaseLocations(user: any, event: Event): void {
    event.stopPropagation();
    this.selectedUser = user;

    // IMPORTANT: Also set userDetails so the drawer condition passes
    this.userDetails = user;

    this.showUserDetails = true;
    this.activeTab = 'locations';
    this.loadBaseLocations();
    this.cdr.detectChanges();
  }
  closeUserDetails(): void {
    this.showUserDetails = false;
    this.selectedUser = null;
    this.showRolePreview = false;
    this.userDetails = null;
    this.showUnblockConfirmation = false;
    if (!this.isLocationChanged) this.loadUsers(true);
    this.assignLocationSearch = '';
    this.applyFilters();
  }

  getSortedAvailableRoles(): any[] {
    return [...this.availableRolesList].sort((a, b) =>
      a.role.localeCompare(b.role)
    );
  }

  showMessage(message: string, color: string) {
    this.message = message;
    this.messageColor = color;
    setTimeout(() => { this.message = ''; this.cdr.detectChanges() }, 3500);
  }


  showMessage1(message: string, color: string) {
    this.message1 = message;
    this.messageColor = color;
    setTimeout(() => { this.message1 = ''; this.cdr.detectChanges() }, 3500);
  }
  showUserMessage(message: string, color: string) {
    this.userMessage = message;
    this.messageColor = color;
    setTimeout(() => { this.userMessage = ''; this.cdr.detectChanges() }, 3500);
  }

  // Action stubs
  disableUser(userId: number) {
    this.usersService.DisableUser(userId).then(() => {
      this.showMessage("User Disabled", "yellow")
      this.loadUsers(true);
    });
  }

  enableUser(userId: number) {
    this.usersService.EnableUser(userId).then(() => {
      this.showMessage("User Enabled", "green")
      this.loadUsers(true);
    });
  }

  confirmUnblockUser() {
    this.showUnblockConfirmation = true;
  }

  unblockUser(userId: number) {
    const payload = {
      id: userId,
      name: this.userDetails.name,
      username: this.userDetails.username,
      recovery_email: this.userDetails.recovery_email
    };
    this.usersService.UnblockUser(payload).then(res => {
      this.showUserMessage("User unblocked successfully", "green")
      this.showUnblockConfirmation = false;
      this.loadUsers(true);
      if (this.userDetails && this.userDetails.user_id === userId) {
        this.closeUserDetails();
      }
    }).catch(err => {
      this.showUserMessage("Failed to Unblock User", "red")
    });
  }

  // ==== Roles Management ====
  loadRolesByUserId() {
    this.activeTab = 'roles';
    const userId = this.selectedUser.id || this.selectedUser.user_id;
    this.usersService.GetAccessRolesByUser(userId).then(roles => {
      this.currentUserRolesList = roles.data || roles || [];
      this.usersService.GetAccessRoles().then(all => {
        this.accessRolesList = all.data || all || [];
        this.isRoleLoaded = true;
        this.isRoleLoading = false;
        this.filterAvailableRoles();
        this.cdr.detectChanges();
      });
    });
  }

  filterAvailableRoles() {
    const existingIds = this.currentUserRolesList.map(r => r.role_id || r.id);
    this.availableRolesList = this.accessRolesList.filter(r => !existingIds.includes(r.id));
  }

  removeUserRole(role: any) {
    this.usersService.DeleteUserRole(role).then(() => {
      this.showUserMessage("Role Removed", "yellow")
      this.loadRolesByUserId();
    }).catch(err => {
      this.showUserMessage("Failed to remove role", "red")
    });
  }

  assignRole(role: any) {
    const roleDetails = {
      user_id: this.selectedUser.id || this.selectedUser.user_id,
      role_id: role.id
    };
    this.usersService.InsertUserRole(roleDetails).then(() => {
      this.showUserMessage("Role Added", "green")
      this.loadRolesByUserId();
    }).catch(err => {
      this.showUserMessage("Failed to assign role", "red")
    });
  }

  // ==== Sessions Management ====
  // ==== Sessions Management ====
  loadSessions() {
    this.activeTab = 'sessions';
    this.isSessionLoading = true;
    this.isSessionLoaded = false;

    const userId = this.selectedUser.id || this.selectedUser.user_id;

    this.usersService.GetSessionsForUser(userId).then(sessions => {
      const rawSessions = sessions?.data || sessions || [];

      // Map over your collection and format to USA Central Time natively
      this.userSessions = rawSessions.map((session: any) => {
        let formattedDateStr = '—';

        if (session.expires) {
          const dateObj = new Date(session.expires);

          // Formats to "MM/DD/YYYY, hh:mm:ss AM/PM" using the Chicago timezone natively
          formattedDateStr = dateObj.toLocaleString('en-US', {
            timeZone: 'America/Chicago',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
          }).replace(',', ''); // Removes the comma to match dev precisely
        }

        return {
          ...session,
          formattedExpires: formattedDateStr
        };
      });

      this.isSessionLoaded = true;
      this.isSessionLoading = false;
      this.cdr.detectChanges();
    }).catch(err => {
      console.error(err);
      this.userSessions = [];
      this.isSessionLoaded = true;
      this.isSessionLoading = false;
      this.showUserMessage("Failed to load sessions", "red");
      this.cdr.detectChanges();
    });
  }

  clearSessions() {
    const userId = this.selectedUser.id || this.selectedUser.user_id;
    this.usersService.ClearSessions(userId).then(() => {
      this.showUserMessage("Sessions Cleared", "yellow")
      this.loadSessions();
    }).catch(err => {
      this.showUserMessage("Failed to clear sessions", "red")
    });
  }

  openCreateForm() {
    this.isCreateUser = true;
    this.userFormObj = { status: '' };
    this.policyErrors = [];  // Add this line

    // Add this try-catch block
    this.settingsService.GetPasswordPolicy(true).then((res: any) => {
      this.passwordPolicy = res;
    }).catch(() => {
      this.passwordPolicy = { data: [{ minimum_length: 5, contain_lower_case: 1 }] };
    });
  }
  closeCreateForm() {
    this.isCreateUser = false;
    this.errorMessage = null;
  }
  saveUser() {
    // 1. Reset messages
    this.errorMessage = null;
    this.createmessage = null;

    // 2. Front-end Validation
    if (!this.userFormObj.name || !this.userFormObj.username || !this.userFormObj.password) {
      this.errorMessage = "Please fill all required fields marked with *";
      this.cdr.detectChanges();
      return;
    }

    if (this.userFormObj.password !== this.userFormObj.confirmPassword) {
      this.errorMessage = "Passwords do not match";
      this.cdr.detectChanges();
      return;
    }

    if (!this.userFormObj.recovery_email) {
      this.errorMessage = "Business email is required";
      this.cdr.detectChanges();
      return;
    }

    // 3. Prepare Payload
    this.userFormObj.status_id = 1;

    // 4. API Call
    this.usersService.CreateUser(this.userFormObj).then(res => {
      // Show success message
      this.createmessage = "User Created Successfully!";
      this.errorMessage = null;
      this.cdr.detectChanges(); // Force UI update



      const newUserId = res.data?.id || res.id || res.user_id || res.inserted_id;

      if (newUserId) {
        const newUser = {
          id: newUserId,
          user_id: newUserId,
          name: this.userFormObj.name,
          username: this.userFormObj.username,
          recovery_email: this.userFormObj.recovery_email,
          status: this.userFormObj.status || 'Active',
          is_blocked: 0
        };

        // Wait 3 seconds so user can see the message
        setTimeout(() => {
          this.createmessage = null;
          this.closeCreateForm();
          this.viewUserDetails(newUser, true);
          this.loadUsers(true);
          this.cdr.detectChanges();
        }, 3000); // Increased to 3 seconds
      }
    }).catch(err => {
      // Handle different error types
      if (err.status === 505 && err.error?.error) {
        // Database error like "User already exists"
        this.errorMessage = err.error.error;
      }
      else if (err.error?.error?.errors) {
        // Validation errors
        const errors = err.error.error.errors;
        const firstError = Object.keys(errors)[0];
        this.errorMessage = errors[firstError][0];
      }
      else {
        // Generic errors
        this.errorMessage = err.error?.error?.error || err.error?.message || "Error creating user";
      }

      this.cdr.detectChanges();

      setTimeout(() => {
        this.errorMessage = null;
        this.cdr.detectChanges();
      }, 3000);
    });
  }

  // Add this method to check password against policy
  checkPasswordPolicy(password: string) {
    this.policyErrors = [];
    const policy = this.passwordPolicy?.data?.[0];

    if (!policy || !password) return;

    if (policy.minimum_length && password.length < policy.minimum_length) {
      this.policyErrors.push(`Minimum ${policy.minimum_length} characters`);
    }
    if (policy.contain_upper_case === 1 && !/[A-Z]/.test(password)) {
      this.policyErrors.push('Need 1 uppercase letter');
    }
    if (policy.contain_lower_case === 1 && !/[a-z]/.test(password)) {
      this.policyErrors.push('Need 1 lowercase letter');
    }
    if (policy.contain_number === 1 && !/[0-9]/.test(password)) {
      this.policyErrors.push('Need 1 number');
    }
    if (policy.contain_special_character === 1 && !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
      this.policyErrors.push('Need 1 special character');
    }
  }

  deleteUserAccount(userId: number) {
    const payload = { user_id: userId };
    this.usersService.DeleteUser(payload).then(() => {
      this.showMessage("User Soft Deleted", "yellow")
      this.closeUserDetails();
      this.loadUsers(true);
    }).catch(err => {
      this.showUserMessage("Failed to Delete User", "red")
    });
  }

  openDeleteModal(userId: number) {
    this.deleteUserId = userId;
    this.deleteMessage = '';
    this.showDeleteModal = true;
    this.cdr.detectChanges(); // Force change detection
  }

  closeDeleteModal() {
    this.showDeleteModal = false;
    this.deleteUserId = null;
    this.deleteMessage = '';
    this.cdr.detectChanges();
  }

  confirmDelete() {
    if (this.deleteUserId) {
      const payload = { user_id: this.deleteUserId };
      this.usersService.DeleteUser(payload).then(() => {
        this.deleteMessage = '✓ User deleted successfully!';
        this.cdr.detectChanges(); // Force change detection
        setTimeout(() => {
          this.closeDeleteModal();
          this.closeUserDetails();
          this.loadUsers(true);
          this.cdr.detectChanges();
        }, 1000);
      }).catch(err => {
        this.deleteMessage = '✗ Failed to delete user';
        this.cdr.detectChanges(); // Force change detection
        setTimeout(() => {
          this.closeDeleteModal();
          this.cdr.detectChanges();
        }, 1000);
      });
    }
  }

  // ==== Password Management ====
  openUpdatePassword() {
    this.isUpdatePassword = true;
    this.passwordFormObj = {};
    this.policyErrors = [];  // Add this line - VERY IMPORTANT!

    this.settingsService.GetPasswordPolicy(true).then((res: any) => {
      this.passwordPolicy = res;
    }).catch(() => {
      this.passwordPolicy = { data: [{ minimum_length: 5, contain_lower_case: 1 }] };
    });
  }
  closeUpdatePassword() {
    this.isUpdatePassword = false;
    this.errorMessage = null;
  }

  resetPassword() {
    this.errorMessage = null;
    this.message = null; // Clear previous success messages

    if (this.passwordFormObj.new_password !== this.passwordFormObj.confirm_new_password) {
      this.errorMessage = "Confirm new password does not match with new password.";
      this.cdr.detectChanges();
      return;
    }

    let resetPasswordObject = {
      id: this.selectedUser.id || this.selectedUser.user_id,
      is_primary: 1,
      new_password: this.passwordFormObj.new_password,
      name: this.selectedUser.name,
      username: this.selectedUser.username,
      recovery_email: this.selectedUser.recovery_email
    };


    this.isResettingPassword = true;  // Disable button


    this.usersService.ResetPassword(resetPasswordObject).then((response: any) => {
      // 1. Set the success message
      this.message = response?.data?.message || "Password updated successfully";
      this.cdr.detectChanges();

      // 2. Delay the closing of the modal by 2 seconds
      setTimeout(() => {
        // this.closeUpdatePassword();
        // Close the modal
        this.message = null;

        // 2. Clear the password fields immediately from the UI
        this.passwordFormObj = {
          new_password: '',
          confirm_new_password: ''
        };
        // this.isUpdatePassword = false; // Directly set the flag to false
        // this.closeUpdatePassword();    // Call your existing cleanup function
        this.isResettingPassword = false;
        this.cdr.detectChanges();
      }, 2000);

    }).catch((error: any) => {
      this.errorMessage = error?.error?.error || "Error resetting password";
      this.isResettingPassword = false;  // Re-enable on error
      this.cdr.detectChanges();
    });
  }

  // ==== Update Profile ====
  openUpdateProfilePanel() {
    this.isUpdateProfile = true;
    this.userFormObj = JSON.parse(JSON.stringify(this.userDetails));
    // sync recovery_email with email_id_business if not present
    this.userFormObj.email_id_business = this.userFormObj.email_id_business || this.selectedUser.recovery_email;
    this.oldUserDetails = JSON.parse(JSON.stringify(this.userFormObj));
  }

  closeUpdateProfilePanel() {
    this.isUpdateProfile = false;
  }


  updateUserDetails() {

    if (this.isUpdating) return;

    const payload = { ...this.userFormObj };

    // Update payload instead of original object
    if (payload.is_blocked === null) {
      payload.is_blocked = 0;
    }

    // Add this validation before making the API call
    if (!payload.name || payload.name.trim() === '') {
      this.errorMessage = "The Name cannot be Null";
      this.isUpdating = false;
      this.cdr.detectChanges();

      setTimeout(() => {
        this.errorMessage = null;
        this.cdr.detectChanges();
      }, 3000);
      return;
    }


    if (payload.phone_office === null) {
      payload.phone_office = '';
    }

    // Add this validation before making the API call
    if (!payload.username || payload.username.trim() === '') {
      this.errorMessage = "The Username cannot be Null";
      this.isUpdating = false;
      this.cdr.detectChanges();

      setTimeout(() => {
        this.errorMessage = null;
        this.cdr.detectChanges();
      }, 3000);
      return;
    }
    payload.id = this.selectedUser.id || this.selectedUser.user_id;
    payload.recovery_email = payload.email_id_business;


    let hasChanges = false;

    for (let key in payload) {

      if (key === 'id' || key === 'user_id' || key === 'details_id') {
        continue;
      }

      const oldValue = this.oldUserDetails[key];
      const newValue = payload[key];

      if ((oldValue ?? '').toString().trim() !== (newValue ?? '').toString().trim()) {
        hasChanges = true;
        break;
      }
    }
    if (hasChanges) {

      this.isUpdating = true;

      if (payload.salesperson_no === '') {
        payload.salesperson_no = null;
      }



      this.usersService.UpdateUser(payload).then(() => {
        return this.usersService.UpdateUserDetails(payload);
      }).then(() => {

        this.message1 = null;
        this.errorMessage = null;

        this.message1 = "User updated successfully";

        this.oldUserDetails = JSON.parse(JSON.stringify(payload));

        this.viewUserDetails(this.selectedUser);
        this.loadUsers(true);

        this.cdr.detectChanges();

        setTimeout(() => {
          this.closeUpdateProfilePanel();
          this.message1 = null;
          this.isUpdating = false;
          this.cdr.detectChanges();
        }, 2000);

      }).catch((err: any) => {

        this.isUpdating = false;
        this.errorMessage = err.error?.error || err.message || "Update failed";
        this.cdr.detectChanges();

        setTimeout(() => {
          this.errorMessage = null;
          this.cdr.detectChanges();
        }, 2000);


      });

    } else {

      this.message1 = null;
      this.errorMessage = null;

      this.message1 = "Nothing to update";

      this.cdr.detectChanges();

      setTimeout(() => {
        this.message1 = null;
        this.cdr.detectChanges();
      }, 2000);
    }
  }
  loadBaseLocations() {
    this.activeTab = 'locations';
    const userId = this.selectedUser.id || this.selectedUser.user_id;
    this.usersService.GetUserBaseLocations(userId).then(response => {
      this.baseLocationsList = response || [];
      this.isLocationLoaded = true;
      this.isLocationLoading = false;

      if (!this.allLocationsList || this.allLocationsList.length === 0) {
        this.usersService.GetLocations().then(locs => {
          this.allLocationsList = locs || [];
          this.filterAvailableLocations(); // Add this
          this.cdr.detectChanges();
        });
      } else {
        this.filterAvailableLocations(); // Add this
        this.cdr.detectChanges();
      }
    });
  }

  filterAvailableLocations() {
    const assignedIds = this.baseLocationsList.map(l => l.base_location_id || l.id);

    this.availableLocationsList = this.allLocationsList
      .filter(l => !assignedIds.includes(l.location_id || l.id))
      .sort((a, b) => {
        const nameA = (a.base_location || a.name || '').toLowerCase();
        const nameB = (b.base_location || b.name || '').toLowerCase();
        return nameA.localeCompare(nameB);
      });
  }

  addBaseLocation(locationId: string, locationName: string) {
    const userId = this.selectedUser.id || this.selectedUser.user_id;
    this.usersService.SetBaseLocation(userId, locationId).then(() => {
      this.showMessage1("Location Assigned", "green")
      this.loadBaseLocations();
      this.assignLocationSearch = '';
      this.selectedAssignLocationId = '';     // Add this
      this.selectedAssignLocationName = '';   // Add this
      this.cdr.detectChanges();
    }).catch(err => {
      this.showMessage("Failed to Assign Location", "red");
    });
  }
  // Add these to your variable declarations
  showRolePreview = false;
  isPreviewLoading = false;
  selectedPreviewRoleName = '';
  previewPermissions: any[] = [];

  previewRolePermissions(role: any) {
    this.selectedPreviewRoleName = role.role;
    this.showRolePreview = true;
    this.isPreviewLoading = true;
    this.previewPermissions = [];

    // 1. Fetch all possible entities to build the table rows
    this.rolesService.GetAllEntities().then((entities: any) => {
      const allEntities = Array.isArray(entities) ? entities : (entities.data || []);

      // 2. Fetch permissions actually assigned to this role
      return this.rolesService.GetRolePermission(role.id).then((response: any) => {
        const assigned = response.data || response || [];

        // 3. Map assigned permissions onto the full entity list
        this.previewPermissions = allEntities.map((ent: any) => {
          const entName = ent.entity || ent.name;
          // Filter assigned perms for this specific entity
          const matches = assigned.filter((a: any) => a.entity === entName || a.entity_id === ent.id);

          return {
            entity: entName,
            create: matches.some((m: any) => m.permission.toLowerCase() === 'create'),
            view: matches.some((m: any) => m.permission.toLowerCase() === 'view'),
            update: matches.some((m: any) => m.permission.toLowerCase() === 'update'),
            delete: matches.some((m: any) => m.permission.toLowerCase() === 'delete'),
            drop: matches.some((m: any) => m.permission.toLowerCase() === 'drop')
          };
        });

        this.isPreviewLoading = false;
        this.cdr.detectChanges();
      });
    }).catch(err => {
      console.error("Preview failed", err);
      this.isPreviewLoading = false;
      this.showRolePreview = false;
      this.cdr.detectChanges();
    });
  }

  removeBaseLocation(locationId: string): void {
    this.isLocationChanged = true;
    const userId = this.selectedUser.id || this.selectedUser.user_id;

    // Find the name of the location we are removing
    const targetLocation = this.allLocationsList.find((loc: any) =>
      (loc.id === locationId || loc.location_id === locationId)
    );

    // Store the name for the UI bind
    const removedLocationName = targetLocation?.base_location || targetLocation?.name;

    this.usersService.RemoveBaseLocation(userId, locationId).then(() => {
      this.showMessage1("Location Removed", "yellow");

      // BINDING FIX: If the user was filtering by this location, 
      // force the model to keep that value so the dropdown doesn't go blank.
      if (this.locationFilter === removedLocationName) {
        this.locationFilter = removedLocationName;
      }

      this.loadBaseLocations();

      // Update local table data
      const userIndex = this.allUsers.findIndex((u: any) => u.id === userId || u.user_id === userId);
      if (userIndex !== -1) {
        const updatedUser = { ...this.allUsers[userIndex] };
        if (updatedUser.all_locations && removedLocationName) {
          updatedUser.all_locations = updatedUser.all_locations.filter((loc: string) => loc !== removedLocationName);
          updatedUser.searchable_locations = updatedUser.all_locations.join(', ');
          this.allUsers[userIndex] = updatedUser;

          // Refresh table - it will now show "0 users" but the dropdown stays on "Amazon"
          this.applyFilters();
        }
      }
      this.cdr.detectChanges();
    });
  }
  // ==== Preferences Management ====
  loadPreferences() {
    this.activeTab = 'preferences';
    const userId = this.selectedUser.id || this.selectedUser.user_id;
    this.usersService.GetPreferencesByUserId(userId).then(response => {
      this.allPreferences = response.data || response || [];
    }).catch(err => {
      this.errorMessage = "Failed to load preferences.";
    });
  }

  resetPreferencesForUser() {
    const userId = this.selectedUser.id || this.selectedUser.user_id;
    this.usersService.ResetPreferencesToDefault(userId).then(() => {
      this.message = "Preferences set to default.";
      this.loadPreferences();
    });
  }

  // --- Column Settings ---
  showHideColumnSettings(): void {
    this.isColumnSettingsVisible = !this.isColumnSettingsVisible;
  }

  toggleColumn(col: string): void {
    this.columnVisibility[col] = !this.columnVisibility[col];
  }
}